<template>
  <router-link v-bind="routerLinkProps" @click="emit('navigate')" v-slot="{ isActive }">
    <span
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
      :class="isActive ? 'bg-primary/10 text-primary' : 'text-gray-600 hover:bg-surface-100'"
    >
      <i
        :class="[
          isActive ? 'text-primary' : 'text-gray-400',
          icon ? icon : 'pi pi-code invisible',
          '!text-sm transition-colors',
        ]"
      />
      <span class="truncate">{{ label }}</span>
    </span>
  </router-link>
</template>

<script setup lang="ts">
import { RouterLinkProps } from "vue-router";

const { icon, label, ...routerLinkProps } = defineProps<
  {
    icon?: string;
    label: string;
  } & RouterLinkProps
>();

const emit = defineEmits<{ navigate: [] }>();
</script>
